module.exports = __webpack_public_path__ + "media/images/lp_consultation/professional03-b412053c6e8a8d7b4f2131cf0715022f.jpg";